import {
  isIframe,
  isScript,
} from './tagUtils'


/**
 * @param {HTMLElement} element
 *
 * @returns {Function}
 */
export default function makeSetAttribute(element) {
  /**
   * @param {string} name - the name of the attribute to set
   * @param {string | number} value - the new value of the attribute
   */
  return function setAttribute(name, value) {
    if ( isScript(element) ) {
      HTMLScriptElement.prototype.setAttribute.call(element, name, value)
      return
    }

    if ( isIframe(element) ) {
      HTMLIFrameElement.prototype.setAttribute.call(element, name, value)
      return
    }

    element[name] = value
  }
}
